export default {
  languageOptionsLabel: 'Preview language',
  playAgainBtn: 'Replay',
  navbar: {
    backEdit: 'Back to Edit',
    openBrowser: 'Open in browser',
    logoTitle: 'Back to My Project',
  },
}
